import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)
import router from 'vue-router'
export default new Vuex.Store({
  state: {
    sidebar: {

      //Cookies.get('sidebarStatus') Cookies.get('sidebarStatus')
      // opened:  localStorage.getItem("sidebarStatus")  ? !!+localStorage.getItem('sidebarStatus') : true,
      opened: true,
      withoutAnimation: false
    },
    device: 'desktop',
    userInfo: null,
    loading: false,
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    menus: [],
    menusPath: [],
    currentRouterTableName: '323232',
    rightNav: {},
    noMenuPages: [ // 没有菜单的页面
      {path: '/dashboard', title: '首页'},
      {path: '/user/profile', title: '个人信息'},
      {path: '/user/changepwd', title: '修改密码'},
      {path: '/check/add', title: '新增隐患'},
      {path: '/abar/abarbeitung', title: '隐患整改'},
      {path: '/review/review', title: '隐患复查'},
      {path: '/review/reviewaudit', title: '隐患复查审核'},
      {path: '/MajorHazard/MajorHazard', title: '重大隐患处理'},
      {path: '/approvalList', title: '审批'},
      {path: '/report/reportEdit', title: '排查编辑'},
      {path: '/review/detail', title: '隐患详情'},
      {path: '/knowledgeBase/lawList', title: '法律法规'},
      {path: '/knowledgeBase/subList', title: '法律法规'},
      {path: '/HotWork/preliminaryAudit', title: '初步审核'},
      {path: '/HotWork/reportJobFire', title: '动火作业申请'},
      {path: '/HotWork/OnSiteAudit', title: '现场审核'},
      {path: '/HotWork/sign', title: '会签'},
      {path: '/HotWork/workCertificate', title: '作业证打印'},
      {path: '/HotWork/WhenHot', title: '动火作业'},
      {path: '/HotWork/acceptance', title: '验收'},
      {path: '/organization/user', title: '机构人员管理'},
      {path: '/hidden/list', title: '隐患查询'},
      {path: '/check/list', title: '隐患排查'},
      {path: '/lgnitionTask/preliminaryAudit', title: '初步审核'},
      {path: '/lgnitionTask/sign', title: '证件会签'},
      {path: '/lgnitionTask/workCertificate', title: '证件打印'},
      {path: '/lgnitionTask/acceptance', title: '证件验收'},
      {path: '/lgnitionTask/whenHot', title: '证件作业'},
      {path: '/lgnitionTask/listBase', title: '安全措施'},
      {path: '/lgnitionTask/reportJobFire', title: '证件申请'},
      {path: '/messageList', title: '消息通知'},
      {path: '/sisetu', title: '四色图'},
    ],
    tabnavBox: [
      {
        title: '首页',
        path: '/dashboard'
      }
    ]
  },
  mutations: {
    clearAllTab(state, arg) {
      state.tabnavBox = [
        {
          title: '首页',
          path: '/dashboard'
        }
      ];
    },
    addTab(state, arg) {
      console.log('add-tab state', state, arg);
      if (arg.clearTabNav || arg.path == '/dashboard') {
        state.tabnavBox = [];
        if(arg.preNode) {
          state.tabnavBox.push({
            title: arg.preNode.name
          });
        }
      }

      //自动退回
      let pIndex =  -1;
      for (let key in state.tabnavBox) {

        let item = state.tabnavBox[key];
        if (item.path == arg.path) {
          pIndex = parseInt(key);
          continue;
        }
      }
      if (pIndex != -1) {
        state.tabnavBox = state.tabnavBox.slice(0, pIndex + 1);
        return;
      }

      let tabItem = {
        title: arg.title,
        path: arg.path
      };

      if (!tabItem.title || tabItem.title == 'false') {
        tabItem.title = sessionStorage.getItem("currentRouterTableName");
      }
      state.tabnavBox.push(tabItem);

    },
    openMenu(state, arg) {
      state.rightNav = arg
    },
    removeTab(state, arg) {
      let index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path
      })
      state.tabnavBox.splice(index, 1)
      if (arg.tabItem.path === arg.fullPath) { // 移除当前导航时
        let tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1]
        arg.router.push(tabActive.path)
      }
    },
    removeOtherTab(state, arg) {
      state.tabnavBox = [{
        title: '首页',
        path: '/dashboard'
      }]
      if (arg.all) {
        arg.router.push('/dashboard')
        return false
      }
      state.tabnavBox.push(arg.tabItem)
      arg.router.push(arg.tabItem.path)
    },
    collapse(state, arg) {
      state.isCollapse = !state.isCollapse
      if (state.logoShow) {
        setTimeout(function () {
          state.logoShow = false
        }, 300)
      } else {
        state.logoShow = true
      }
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        localStorage.setItem('sidebarStatus', 1)
        // Cookies.set('sidebarStatus', 1)
      } else {
        // Cookies.set('sidebarStatus', 0)
        localStorage.setItem('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      // Cookies.set('sidebarStatus', 0)
      localStorage.setItem('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },
  actions: {
    addTab({commit}, arg) {
      commit('addTab', arg)
    },
    clearAllTab({commit}, arg) {
      commit('clearAllTab', arg)
    },
    openMenu({commit}, arg) {
      commit('openMenu', arg)
    },
    removeTab({commit}, arg) {
      commit('removeTab', arg)
    },
    removeOtherTab({commit}, arg) {
      commit('removeOtherTab', arg)
    },
    collapse({commit}, arg) {
      commit('collapse', arg)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    logout({ commit }) {
      window.localStorage.removeItem('access-token');
      window.localStorage.removeItem('menus');
      window.localStorage.removeItem('userinfo')
      router.replace('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js